import { Component, Input, ViewEncapsulation } from '@angular/core';

import { DeviceDetectorService } from 'ngx-device-detector';

import { PrintService } from '../../../core/services/print.service';
import { SsrHelperService } from '../../../core/services/ssr-helper.service';

import { isValidDate } from '../../helpers/helpers';

import moment from 'moment';
import { GoogleAnalyticService } from '../../../core/services/google-analytic.service';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-trip-plan-print',
  templateUrl: './trip-plan-print.component.html',
  styleUrls: ['./trip-plan-print.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class TripPlanPrintComponent {
  @Input() tripId: string = 'alone';
  @Input() tripName: string = '';
  private items: any[] = [];

  constructor(
    private printService: PrintService,
    private deviceDetectorService: DeviceDetectorService,
    private readonly googleAnalyticService: GoogleAnalyticService,
    private readonly authService: AuthService,
  ) {}

  get itineraryItems(): any[] {
    return this.items;
  }

  @Input() set itineraryItems(items: any) {
    if (items && items.length) {
      this.items = items;
    }
  }

  formatDate(date: string): string {
    date = date.replace(/^[A-Za-z.]*/g, '').trim();
    const formatted = moment(new Date(date)).format('ddd MMM DD');
    const split = formatted.split(' ');
    split[0] += '.';
    split[1] += ' ';

    return split.join(' ');
  }

  tripPlanPrint(): void {
    this.googleAnalyticService.setTripTitleStripAnalytic({
      trip_title_strip: 'print',
      userID: this.authService.userId,
    });

    if (this.isAndroid()) {
      this.printService.print('testPrint', 'RoutePerfect - Test Android print');
      return;
    }

    this.printService.print(
      `tripPlanPrint-${this.tripId}`,
      'RoutePerfect - Trip Planner',
    );
  }

  isValidDate(date: string): boolean {
    return isValidDate(date);
  }

  isAndroid(): boolean {
    const device: string = this.deviceDetectorService.device;
    return !!device.toLowerCase().includes('android');
  }
}
